import { FC, useContext, useEffect, useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { twJoin } from "tailwind-merge";
import BasicInfoSection from "./BasicInfoSection";
import NoticeBoard from "./NoticeBoard";
import { UserDataContext } from "../../userProfile";
import { ProfileUploadIcon } from "../common/Icons";
import axios from "../../axios";
import { endpointUrl } from "../../app/services/api";
import CommonErrorPopup from "../common/CommonErrorPopup";
import styles from "./UserInfo.module.scss";
import { NavLink } from "react-router-dom";
import { ProfileContext } from "../UserProfile/UserProfile";
import { Camera, CameraResultType } from '@capacitor/camera';
import UserInformation from "../common/UserInformation/UserInformation";
interface IUserInfo {
  loginData: any;
  props: any;
}
const profile_routes = [
  {
    label: "basic_info",
    link: "/profile",
  },
  {
    label: "notice_board",
    link: "/profile/notice_board",
  },
];
export const image_type = [
  "svg+xml",
  "png",
  "jpeg",
  "webp",
  "gif",
  "tiff",
];
const UserInfo = (props: any) => {
  const { activeTab, showDot } = props;
  const {t}=useTranslation();
  const data = useContext(UserDataContext);
  const profileContext: any = useContext(ProfileContext);
  const [profileData, setProfile] = useState<any>(
    profileContext?.profileData?.employee
  );
  const popupSatatus = profileContext.profileData?.popupSatatus;
  const loginData: any = data;
  const [profileImage, setProfileImage] = useState<string>(
    loginData?.user?.employee?.photo
  );
  const profileImageRef = useRef<HTMLInputElement>(null);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const changeProfileImage = () => {
    profileImageRef.current?.click();
  };
  const takePicture = async () => {
    console.log("take picture")
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri
    }).then(async (result) => {
      setProfileImage(result.webPath ?? '');
      document.getElementById("profileImage")?.setAttribute("src", result.webPath ?? '');
      if (image_type.includes(result.format)) {
        if (result.webPath) {
          const response = await fetch(result.webPath)?.then((res) => {
            const blob = res.blob();
            blob.then((re) => {
              console.log("blob success ", JSON.stringify(re))
              var file = new File([re], "profile_image_"+new Date().getTime()+".jpg", {lastModified: new Date().getTime()});
              uploadFileFunc(file);
            })

          });

        }
      } else {
        setErrorMsg("The uploaded file should be image type.");
      }
    }).catch((error)=>{
      console.log("error ",error);
    })

  };
  const changeProfile = (e: any) => {
    var filesize = Math.round(e.target.files[0]?.size / 1000) / 1024;
    if (filesize > 2) {
      setErrorMsg("The uploaded image size is greater than 2mb. ");
      return;
    }
    var url = URL.createObjectURL(e.target.files[0]);
    setProfileImage(url);
    document.getElementById("profileImage")?.setAttribute("src", url);
    if (image_type.includes(e.target.files[0].type)) {
      uploadFileFunc(e.target.files[0]);
    } else {
      setErrorMsg("The uploaded file should be image type.");
    }
  };
  const uploadFileFunc = async (file: any) => {
    if (file) {
      let formSaveData = new FormData();
      formSaveData.append("file", file);
      await axios(endpointUrl + "profile/upload_profile", {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formSaveData,
      })
        .then((res: any) => {
          setProfile(res?.data?.employee);
          setProfileImage(res?.data?.employee?.photo);
          profileContext.changeProfileData(res?.data);
          console.log("upload success ",JSON.stringify(res?.data))
        })
        .catch((err) => {
          console.log("upload error ",JSON.stringify(err))
          setErrorMsg(err?.response?.data.message);
        });
    }
  };
  useEffect(() => {
    setProfile(profileContext?.profileData?.employee);
    setProfileImage(profileContext?.profileData?.employee?.photo);
  }, [profileContext]);
  
  return (
    <div className="">
      <UserInformation/>
      <div className="mt-6 mb-[10px] px-5">
        <h3 className="heading3 font-bold leading-[normal] text-sat_darkblackv2 text-left">Basic Info</h3>
        <div>{props.children}</div>
      </div>
      <CommonErrorPopup
        show={errorMsg != "" ? true : false}
        setShow={() => setErrorMsg("")}
        message={errorMsg}
      />
    </div>
  );
};
export default withTranslation('common')(UserInfo);
